<template>
  <div class="sub-page">
    <van-nav-bar :title="$t('setting.sex_place')" class="nav-bar">
      <template #left>
        <van-icon name="arrow-left" color="#c9a84c" size="20" @click="back()" />
      </template>
    </van-nav-bar>
    <div class="card sex">
        <van-radio-group v-model="radio">
          <div class="item" @click="chooesSex(1)">
              <van-radio name="1" checked-color="#c9a84c">{{$t("setting.man")}}</van-radio>
          </div>
          <div class="item" @click="chooesSex(2)">
            <van-radio name="2" checked-color="#c9a84c">{{$t("setting.female")}}</van-radio>
          </div>
        </van-radio-group>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      radio:"",
      userInfo:{}
    };
  },
  methods: {
    back(){
      return window.history.back();
    },
    chooesSex(sex){
      this.$http({
        method: 'post',
        data:{sex:sex},
        url: 'user_set_sex'
      }).then(res=>{
        if(res.code === 200){
          this.getUserInfo();
          this.radio = sex;
          this.$toast(res.msg);
        }else if(res.code ===401){
          this.$toast(res.msg);
        }
      })
    },
    getUserInfo(){
      console.log(window.localStorage.getItem("lang").toLowerCase())
      this.$http({
        method: 'get',
        url: 'user_info',
        headers: {
          lang: window.localStorage.getItem("lang").toLowerCase()
        }
      }).then(res=>{
        if(res.code === 200){
          this.userInfo = res.data;
          this.radio = res.data.sex;
        }else if(res.code ===401){
          this.$toast(res.msg);
        }
      })
    }
  },
  created() {
    if(!localStorage.getItem('token')){
      this.$router.push({path:'/Login'})
    }else {
      this.getUserInfo();
    }
  }
};
</script>

<style lang='less' scoped>
.sub-page{
  min-height: 100vh;
  background: #000000;
}
.card.sex{
  background: #141414;
  border-radius: 16px;
  margin: 24px;
  padding: 10px 28px;
}
.sex .item{
  font-size: 32px;
  padding: 34px 0;
  border-bottom: 1px solid rgba(201,168,76,0.2);
  &:last-child{
    border-bottom: none;
  }
}
::v-deep .van-radio__label {
  margin-left: 24px;
  color: #c9a84c;
}
::v-deep .van-radio__icon--checked .van-icon {
  color: #fff;
  border-color: #c9a84c;
  background-color: #c9a84c;
}
</style>
